"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const jsonpath_1 = tslib_1.__importDefault(require("jsonpath"));
exports.IsJSONPath = (validationOptions) => {
    return (object, propertyName) => {
        class_validator_1.registerDecorator({
            async: true,
            name: 'isJsonPathValid',
            options: validationOptions,
            propertyName,
            target: object.constructor,
            validator: {
                validate(value) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        if (!value) {
                            return true;
                        }
                        try {
                            jsonpath_1.default.parse(value);
                            return true;
                        }
                        catch (e) {
                            return false;
                        }
                    });
                },
            },
        });
    };
};
//# sourceMappingURL=IsJSONPath.js.map